import VirtualDynamicTable from './VirtualDynamicTable';
import './VirtualDynamicTable.scss';

export default VirtualDynamicTable;
